<template>
  <b-modal
    ref="mbvba_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px] pt-[28px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="icon-popup-warning"
        class="w-[100px] h-[100px] mx-auto mb-[24px]"
      >
      <h3 class="text-[18px] text-[#333333] font-semibold text-center">
        Konfirmasi Persetujuan
      </h3>
      <p class="text-[#626262] text-[16px] font-normal text-center mb-[28px]">
        Tim Operasional Kompack sedang memeriksa pengajuan nominal pengajuan terbaru. Proses ini biasanya memakan waktu hingga 1x24 jam. Mohon ditunggu sebentar ya 🙂
      </p>
      <div class="flex items-center gap-[8px] mt-[16px]">
        <b-button
          block
          variant="primary"
          class="!flex items-center justify-center gap-[8px] mt-0"
          @click="hide"
        >
          Lanjutkan
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>

/**
 * ModalBeingVerifiedByAdmin
 * @description ModalBeingVerifiedByAdmin is a component that displays the modal being verified by admin
 * @returns {Object} ModalBeingVerifiedByAdmin
 */
export default {
  name: 'ModalBeingVerifiedByAdmin',
  methods: {
    show() {
      this.$refs.mbvba_kompack.show()
    },
    hide() {
      this.$refs.mbvba_kompack.hide()
    },
  },
}
</script>
